import styled from 'styled-components'

export const ModalBody = styled.div`
  padding: 15px;
`

export const ModalTextContent = styled.div``

export const ModalText = styled.p`
  font-size: 1rem;
`

export const ModalFooter = styled.div`
  border-top: 1px solid #c4c4c4;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top: 10px;
  padding-top: 10px;
`

const BaseButton = styled.button`
  min-width: 100px;
  color: #fff;
  padding: 4px 16px;
  margin-right: 5px;
  border-radius: 8px;
  box-shadow: 0px 3px 14px rgba(0, 0, 0, 0.16);
  border: 0;
  cursor: pointer;
  :hover {
    transition: 200ms ease-in-out;
  }
`

export const ConfirmButton = styled(BaseButton)`
  background-color: ${(props) => props.theme.colors.confirm};
  :hover {
    background-color: ${(props) => props.theme.colors.confirmHover};
  }
`

export const CancelButton = styled(BaseButton)`
  background-color: ${(props) => props.theme.colors.cancel};
  :hover {
    background-color: ${(props) => props.theme.colors.cancelHover};
  }
`
